/* ==========================================================================
   Maison Carthia - L'Etagere controller
   ==========================================================================
   <mc-etagere-shelf>: select exactly three shelf tiles, keep a live tally
   (count / was / now), and add the three chosen 10 mL variants in one POST.

   SUBSCRIBE-only: this file never publishes cartUpdate and adds no new
   publisher. The drawer and header count stay consistent through Shopify
   section rendering (cart.renderContents), exactly as the live PDP add does.
   ========================================================================== */
(function () {
  if (customElements.get('mc-etagere-shelf')) return;

  var MAX = 3;

  customElements.define(
    'mc-etagere-shelf',
    class MCEtagereShelf extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-item]'));
        this.picksEl = this.querySelector('[data-picks]');
        this.wasEl = this.querySelector('[data-was]');
        this.nowEl = this.querySelector('[data-now]');
        this.atcEl = this.querySelector('[data-atc]');
        this.errEl = this.querySelector('[data-err]');

        this.selection = []; // ordered list of selected buttons
        this.busy = false;

        this.currency = this.dataset.currency || 'USD';
        this.locale = this.dataset.locale || 'en';
        this.savings = parseFloat(this.dataset.savingsPercent) || 0;
        this.emptyText = this.dataset.emptyText || '';
        this.picksPrefix = this.dataset.picksPrefix || '';
        this.hintSwap = this.dataset.hintSwap || '';
        this.ctaLabel = (this.atcEl && this.atcEl.textContent.trim()) || this.dataset.ctaLabel || '';
        this.addingLabel = this.dataset.addingLabel || this.ctaLabel;

        this.items.forEach(
          function (btn) {
            if (btn.disabled) return;
            btn.addEventListener('click', this.onToggle.bind(this, btn));
          }.bind(this)
        );

        if (this.atcEl) this.atcEl.addEventListener('click', this.onAdd.bind(this));

        this.render();
      }

      onToggle(btn) {
        if (btn.disabled) return;
        var idx = this.selection.indexOf(btn);

        if (idx > -1) {
          // deselect
          this.selection.splice(idx, 1);
          btn.classList.remove('is-on');
          btn.setAttribute('aria-pressed', 'false');
          this.clearError();
          this.render();
          return;
        }

        if (this.selection.length >= MAX) {
          // full: hint to swap, change nothing
          this.showHint();
          return;
        }

        this.selection.push(btn);
        btn.classList.add('is-on');
        btn.setAttribute('aria-pressed', 'true');
        this.clearError();
        this.render();
      }

      showHint() {
        if (this.picksEl) this.picksEl.textContent = this.hintSwap;
      }

      formatMoney(cents) {
        var value = cents / 100;
        try {
          // en-CA yields the narrow "$" (matching the store money_format
          // ${{amount}}), not the "CA$" the region-less request locale produces.
          return new Intl.NumberFormat('en-CA', {
            style: 'currency',
            currency: this.currency,
            minimumFractionDigits: cents % 100 ? 2 : 0,
          }).format(value);
        } catch (e) {
          return '$' + (cents % 100 ? value.toFixed(2) : value.toFixed(0));
        }
      }

      sum() {
        return this.selection.reduce(function (total, btn) {
          return total + (parseInt(btn.dataset.price, 10) || 0);
        }, 0);
      }

      render() {
        var count = this.selection.length;

        // lock / unlock the unselected tiles once three are chosen
        var full = count >= MAX;
        this.items.forEach(
          function (btn) {
            if (btn.disabled) return;
            var on = this.selection.indexOf(btn) > -1;
            if (full && !on) {
              btn.classList.add('is-locked');
              btn.setAttribute('aria-disabled', 'true');
            } else {
              btn.classList.remove('is-locked');
              btn.removeAttribute('aria-disabled');
            }
          }.bind(this)
        );

        // picks line
        if (this.picksEl) {
          if (count === 0) {
            this.picksEl.textContent = this.emptyText;
          } else {
            this.picksEl.textContent = '';
            this.picksEl.appendChild(document.createTextNode(this.picksPrefix + ' · '));
            var strong = document.createElement('b');
            strong.textContent = this.selection
              .map(function (btn) {
                return btn.dataset.name;
              })
              .join(', ');
            this.picksEl.appendChild(strong);
          }
        }

        // price group
        var total = this.sum();
        if (count === 0) {
          this.hide(this.wasEl);
          this.hide(this.nowEl);
        } else if (this.savings > 0 && count === MAX) {
          var discounted = Math.round(total * (1 - this.savings / 100));
          if (this.wasEl) {
            this.wasEl.textContent = this.formatMoney(total);
            this.show(this.wasEl);
          }
          if (this.nowEl) {
            this.nowEl.textContent = this.formatMoney(discounted);
            this.show(this.nowEl);
          }
        } else {
          this.hide(this.wasEl);
          if (this.nowEl) {
            this.nowEl.textContent = this.formatMoney(total);
            this.show(this.nowEl);
          }
        }

        // CTA enablement
        if (this.atcEl) {
          if (count === MAX) {
            this.atcEl.removeAttribute('aria-disabled');
          } else {
            this.atcEl.setAttribute('aria-disabled', 'true');
          }
        }
      }

      onAdd(event) {
        event.preventDefault();
        if (this.busy) return;
        if (this.selection.length !== MAX) return;

        this.busy = true;
        this.clearError();
        if (this.atcEl) this.atcEl.textContent = this.addingLabel;

        var cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        var body = {
          items: this.selection.map(function (btn) {
            return { id: Number(btn.dataset.variantId), quantity: 1 };
          }),
        };
        if (cart) {
          body.sections = cart.getSectionsToRender().map(function (s) {
            return s.id;
          });
          body.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(body);

        fetch(routes.cart_add_url, config)
          .then(function (response) {
            return response.json();
          })
          .then(
            function (json) {
              if (json.status) {
                // Cart API error (e.g. a variant just sold out)
                this.showError(json.description || json.message || '');
                return;
              }
              if (!cart) {
                window.location = routes.cart_url;
                return;
              }
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              // One call re-renders cart-drawer + cart-icon-bubble and opens the
              // drawer. No publish(): SUBSCRIBE-only, no new cartUpdate publisher.
              cart.renderContents(json);
              this.resetSelection();
            }.bind(this)
          )
          .catch(
            function () {
              this.showError('');
            }.bind(this)
          )
          .finally(
            function () {
              this.busy = false;
              if (this.atcEl) this.atcEl.textContent = this.ctaLabel;
            }.bind(this)
          );
      }

      resetSelection() {
        this.selection.forEach(function (btn) {
          btn.classList.remove('is-on');
          btn.setAttribute('aria-pressed', 'false');
        });
        this.selection = [];
        this.render();
      }

      showError(message) {
        if (!this.errEl) return;
        this.errEl.textContent = message || 'Something went wrong. Please try again.';
        this.errEl.hidden = false;
      }

      clearError() {
        if (!this.errEl) return;
        this.errEl.textContent = '';
        this.errEl.hidden = true;
      }

      show(el) {
        if (el) el.hidden = false;
      }

      hide(el) {
        if (el) el.hidden = true;
      }
    }
  );
})();
